import React, { useEffect, useState } from 'react';
import { Descriptions, Badge, Layout, Row, Col, Card, Button } from 'antd';

import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import {
  FactoriesInput,
  PlantInvoiceDetailsModel,
  PlantInvoiceDetailsRequest,
  SaleOrderDetailViewInfoDTO,
  UnitsOfWeightInput,
} from '@gtpl/shared-models/sale-management';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { ExporterDataInput } from '@gtpl/shared-models/logistics';
import { SaleOrderIdRequest, UomEnum } from '@gtpl/shared-models/common-models';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { useLocation } from 'react-router-dom';
import moment from 'moment';


// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';

/* eslint-disable-next-line */
export interface IsfWorksheetProps {
  // props: any;
  saleOrderId: number;
  soData: SaleOrderDetailViewInfoDTO;
  isPresailing: boolean;
}

export function IsfWorksheet(
  props: IsfWorksheetProps
) {
  const salOrderService = new SaleOrderService();
  const [plantDetails, setPlantDetails] = useState<PlantInvoiceDetailsModel>();
  const [linerAddress, setLinerAddress] = useState<any>([]);

  const [singleproductData, setSingleProductData] = useState<any[]>([]);

  let totalCases = 0;
  let totalGrossWeight = 0;
  let totalLbWeight = 0;
  let totalAmount = 0;
  let lbPouchWeight
  let kgPouchWeight
  let packSize;

  // const printOrder = () => {
  //   const printableElements = document.getElementById('printme').innerHTML;
  //   const orderHTML = '<html><head><title></title></head><body>' + printableElements + '</body></html>'
  //   const oldPage = document.body.innerHTML;
  //   document.body.innerHTML = orderHTML;
  //   // document.body.innerHTML = oldPage
  //   window.print();

  // }

  useEffect(() => {
    if (props.saleOrderId) {
      getLinerAddressForIsfWorksheet(props.saleOrderId);
    }
  }, [props.saleOrderId])

  const getLinerAddressForIsfWorksheet = (saleOrderId) => {
    // const req=new SoFormSdfPrintDto()
    salOrderService.getLinerAddressForIsfWorksheet(new SaleOrderIdRequest(props.saleOrderId)).then(res => {
        if (res.status) {
          setLinerAddress(res.data)
        }
    })
}

  const getData = (saleOrderId) => {
    // const reqObj = new PlantInvoiceDetailsRequest(1);
    salOrderService.getPlantInvoiceDetails({ saleOrderId: saleOrderId }).then((res) => {
      console.log(res);
      if (res.status) {
        console.log(res);
        setPlantDetails(res.data);
        const output = [...new Map(res.data?.saleOrderItems?.map(o => [o.foodTypeName && o.itemName && o.valueAdditionOneIdName && o.valueAdditionTwoIdName && o.valueAdditionThreeIdName && o.valueAdditionFourIdName && o.valueAdditionFiveIdName, o])).values()]
        console.log("output");
        console.log(output);
        setSingleProductData(output);

      } else {
        if (res.intlCode) {
          setPlantDetails(undefined);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    })
      .catch((err) => {
        AlertMessages.getErrorMessage(err.message);
        setPlantDetails(undefined);
      });
  };

  useEffect(() => {
    console.log('kkk');
    if (props.saleOrderId) {
      getData(props.saleOrderId);
    }
  }, [])


  let exporterDetails = ExporterDataInput;
  const exporterData = exporterDetails.find(
    (item) => item.value == plantDetails?.exporterId
  );


  let factoryDetails = FactoriesInput;
  let factoryId = 3;
  const unitsData = factoryDetails.find(
    (item) => item.id == plantDetails?.unitId ? plantDetails.unitId : factoryId
  );


  let uom;
  let outputWeight = '';
  plantDetails?.saleOrderItems?.map(item => {
    totalCases += item.cases;
    totalGrossWeight += Number(item.grossWeight);
    console.log(plantDetails)
    console.log(item.cases)
    console.log(item.grossWeight)
    console.log(totalGrossWeight)

    uom = UnitsOfWeightInput.find(uom => uom.value == item.uomId);
    if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
      outputWeight = UomEnum.LB;
    } else if (uom.name == UomEnum.KG || uom.name == UomEnum.Gms) {
      outputWeight = UomEnum.KG; ``
    }

    lbPouchWeight = Number(plantDetails?.saleOrderItems[0].pouchWeight)
    kgPouchWeight = Number(plantDetails?.saleOrderItems[0].pouchWeight)

    if (uom.name == UomEnum.OZ) {
      lbPouchWeight = lbPouchWeight * 0.0625
    }
    if (uom.name == UomEnum.Gms) {
      kgPouchWeight = kgPouchWeight * 0.001
    }

  });


  const grouped = plantDetails?.saleOrderItems?.filter((value, index, self) =>
    index === self.findIndex((t) => (
      t.pouches === value.pouches && t.pouchWeight === value.pouchWeight
    ))
  )



  const productGrouped = plantDetails?.saleOrderItems?.filter((value, index, self) =>
    index === self.findIndex((t) => (
      t.itemName === value.itemName && t.varientCode === value.varientCode
    ))
  )

  const downloadPD = () => {
    const input = document.getElementById('printme');
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save('ISFWorksheet.pdf');
    });
  };

//   const downloadPDF = () => {
//     const pdf = new jsPDF('p', 'mm', 'a4');
//     const element = document.getElementById('printme');

//     // Calculate the width of the PDF based on the available screen size
//     const screenWidth = window.innerWidth;
//     let pdfWidth;

//     if (screenWidth < 768) {
//         // For small screens, set a smaller width
//         pdfWidth = 150;
//     } else {
//         // For larger screens, set the width to fit A4 format
//         pdfWidth = 190;
//     }

//     pdf.html(element, {
//         callback: function (pdf) {
//             // Generate the PDF as a blob
//             const blob = pdf.output('blob');
//             const blobUrl = URL.createObjectURL(blob);

//             // Open the PDF in a new window
//             const newWindow = window.open(blobUrl, '_blank');
//             if (newWindow) {
//                 newWindow.focus();
//             } else {
//                 // Handle pop-up blockers or other issues
//                 console.error('Failed to open PDF in a new window.');
//             }
//         },
//         x: 10,
//         y: 10,
//         width: pdfWidth,
//         windowWidth: element.scrollWidth,
//     });
// }

const downloadPDF = () => {
  const pdf = new jsPDF('p', 'mm', 'a4');
  const element = document.getElementById('printme');

  // Calculate the width of the PDF based on the available screen size
  const screenWidth = window.innerWidth;
  let pdfWidth;

  if (screenWidth < 768) {
      // For small screens, set a smaller width
      pdfWidth = 150;
  } else {
      // For larger screens, set the width to fit A4 format
      pdfWidth = 190;
  }

  pdf.html(element, {
      callback: function (pdf) {
          // Print the PDF directly
          pdf.autoPrint();
          pdf.output('dataurlnewwindow');
      },
      x: 10,
      y: 10,
      width: pdfWidth,
      windowWidth: element.scrollWidth,
  });
};

// finall

// const downloadPDF = () => {
//   const pdf = new jsPDF('p', 'mm', 'a4');
//   const element = document.getElementById('printme');

//   // Fixed width to avoid issues with zoom levels
//   const pdfWidth = 190; // Standard width for A4 in mm

//   // Optional: Ensure that the element is scaled properly
//   const originalTransform = element.style.transform;
//   element.style.transform = 'scale(1)';
//   element.style.transformOrigin = 'top left';

//   pdf.html(element, {
//       callback: function (pdf) {
//           // Restore the original transform after rendering
//           element.style.transform = originalTransform;

//           // Print the PDF directly
//           pdf.autoPrint();
//           pdf.output('dataurlnewwindow');
//       },
//       x: 10,
//       y: 10,
//       width: pdfWidth,
//       windowWidth: element.scrollWidth, // Fixed value to avoid scaling issues
//   });
// };


// const downloadPDF = () => {
//   const pdf = new jsPDF('p', 'mm', 'a4');
//   const element = document.getElementById('printme');

//   // Generate a unique code consisting of two letters and two numbers
//   const generateUniqueCode = () => {
//       const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
//       const numbers = '0123456789';
//       let result = '';
//       // Generate two random letters
//       for (let i = 0; i < 2; i++) {
//           const randomIndex = Math.floor(Math.random() * characters.length);
//           result += characters[randomIndex];
//       }
//       // Generate two random numbers
//       for (let i = 0; i < 2; i++) {
//           const randomIndex = Math.floor(Math.random() * numbers.length);
//           result += numbers[randomIndex];
//       }
//       return result;
//   };

//   // Get today's date in YYYYMMDD format
//   const getCurrentDate = () => {
//       const today = new Date();
//       const year = today.getFullYear();
//       const month = String(today.getMonth() + 1).padStart(2, '0');
//       const day = String(today.getDate()).padStart(2, '0');
//       return `${year}${month}${day}`;
//   };

//   // Calculate the width of the PDF based on the available screen size
//   const screenWidth = window.innerWidth;
//   let pdfWidth;

//   if (screenWidth < 768) {
//       // For small screens, set a smaller width
//       pdfWidth = 150;
//   } else {
//       // For larger screens, set the width to fit A4 format
//       pdfWidth = 190;
//   }

//   const uniqueCode = generateUniqueCode();
//   const currentDate = getCurrentDate();
//   const fileName = `FBGS_${uniqueCode}_${currentDate}.pdf`;

//   pdf.html(element, {
//       callback: function (pdf) {
//           pdf.save(fileName); // Save the PDF with the generated filename
//       },
//       x: 10,
//       y: 10,
//       width: pdfWidth,
//       windowWidth: element.scrollWidth,
//   });
// };




  return (

    <>
      <span style={{ alignContent: 'left', backgroundColor: 'red' }}>
      </span>
      <br />
      <div style={{ textAlign: 'right' }}>
      <Button onClick={downloadPDF} style={{ backgroundColor: '#87CEEB', color: 'white' }}>print</Button></div>
      <br />
      <html>
        <head>

        </head>
        <body id='printme' className='responsive-div'>

          <div style={{letterSpacing:'1px'}}>

            <table style={{ width: '100%', border: "1px solid black" }}>
              <tr>
                <th colSpan={4} className="ta-b">
                  <div style={{height:"130px"}}>
                  <img
                      src="https://res.cloudinary.com/dgpr9ddpm/image/upload/v1716354895/FBGS_ORIG_LOGO_tvhnhy.webp"
                      alt="FBGS Logo"
                      style={{width: '150px', height: '90px' }}
                    />
                    <h1 style={{ textAlign: 'center'}}>
                    FBGS ISF 10+2 Filling Form
                    </h1>
                  </div>
                </th>
              </tr>

              <tr>
                <td style={{paddingRight:"8px"}}><b>ETD :</b><td style={{ border: "1px solid black", width: "250px" }}>&nbsp;{props.isPresailing
    ? moment(plantDetails?.etd).format('DD-MMM-YYYY')
    : plantDetails?.shippedOnboardDate}</td></td>

                {/* <td style={{ border: "1px solid black", width: "250px" }}>
    &nbsp; {props.isPresailing
    ? plantDetails?.shippedOnboardDate
    : plantDetails?.shippedOnboardDate}
  </td></td></td> */}
                <td style={{paddingRight:"8px"}}><b>ETA :</b><td style={{ border: "1px solid black", width: "250px" }}>&nbsp;{(plantDetails?.shippedOnboardDate) ? moment(plantDetails?.shippedOnboardDate).format('DD-MMM-YYYY') : ""}</td></td>
                <td style={{paddingRight:"12px"}}><b>Import of record&nbsp;:</b><td style={{ border: "1px solid black", width: "300px" }}>&nbsp;{exporterData?.importerOfRecord}</td></td>
                <td style={{paddingRight:"12px"}}><b>Consignee&nbsp;:</b><td style={{ border: "1px solid black", width: "300px" }}>&nbsp;{plantDetails?.consignee?plantDetails?.consignee:"-"}</td></td>
              </tr>
              <tr>
                <td style={{paddingRight:"8px"}}><b>Loading Port&nbsp;:</b><td style={{ border: "1px solid black", width: "250px" }}>&nbsp;{(plantDetails?.portOfDischarge ? (plantDetails.portOfDischarge + ',') : '') + (plantDetails?.country ? plantDetails?.country : '')}</td></td>
                <td style={{paddingRight:"8px"}}><b>Discharge port&nbsp;: </b>&ensp;<td style={{ border: "1px solid black", width: "250px" }}>&nbsp;{(plantDetails?.saleOrderItems[0]?.destinationDetails ? (plantDetails?.saleOrderItems[0]?.destinationDetails + ',') : '') + (plantDetails?.country ? plantDetails?.country : '')}</td></td>
                <td style={{paddingRight:"12px"}}><b>Vessel&nbsp;/ Voyage&nbsp;:</b><td style={{ border: "1px solid black", width: "300px" }}>&nbsp;{plantDetails?.vesselName}</td></td>
                <td style={{paddingRight:"12px"}}><b>Weight(KGS )&nbsp;:</b><td style={{ border: "1px solid black", width: "300px" }}>&nbsp;{plantDetails?.grossWeight?plantDetails?.grossWeight:"-"}{""}KGS</td></td>
              </tr>
              <br />
              <tr >
                <td ><b>Master Bill Of Lading #&nbsp;:</b></td>
                <td ><b>Ams House Bill of Lading #&nbsp;:</b></td>
                <td ><b>Container Number:</b></td>
                <td ><b>No. of Pakgs &nbsp;:</b></td>
              </tr>
              <tr >
                <td style={{textAlign:"center"}} className='ta-b'>{plantDetails?.trackingNo}</td>
                <td style={{textAlign:"center"}} className='ta-b'></td>
                <td style={{textAlign:"center"}} className='ta-b'>&ensp;{plantDetails?.saleOrderItems[0].containerNo}</td>
                <td style={{textAlign:"center"}} className='ta-b'>{totalCases}{""}MASTER CARTONS</td>
              </tr>
              <tr >
                <td style={{textAlign:"center"}} className='ta-b'>{}</td>
                <td style={{textAlign:"center"}} className='ta-b'></td>
                <td style={{textAlign:"center"}} className='ta-b'>&ensp;{}</td>
                <td style={{textAlign:"center"}} className='ta-b'></td>
              </tr>
              <tr >
                <td style={{textAlign:"center"}} className='ta-b'>{}</td>
                <td style={{textAlign:"center"}} className='ta-b'></td>
                <td style={{textAlign:"center"}} className='ta-b'>&ensp;{}</td>
                <td style={{textAlign:"center"}} className='ta-b'></td>
              </tr>
              <tr >
                <td style={{textAlign:"center"}} className='ta-b'>{}</td>
                <td style={{textAlign:"center"}} className='ta-b'></td>
                <td style={{textAlign:"center"}} className='ta-b'>&ensp;{}</td>
                <td style={{textAlign:"center"}} className='ta-b'></td>
              </tr>
              <br />
              <tr style={{ fontWeight: "bold" }}>
                <td colSpan={2}>&nbsp;&nbsp; Seller (or Owner)/Name and Address</td>
                <td colSpan={2}>&nbsp;&nbsp; Buyer (or Owner)/Name and Address</td>
              </tr>

                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <tr>
                <td colSpan={2} style={{ paddingLeft:"0px",paddingRight:"20px"}}>
                <div style ={{ border: "1px solid black", paddingLeft:"18px",paddingRight:"10px" }}>
                  {(exporterData?.name) ? exporterData?.name : ''}<br />
                  <h4>SUPPLIERS &nbsp;( SELLER &nbsp;) ADDRESS &nbsp; :</h4>
                  {(exporterData?.addressOne) ? exporterData?.addressOne + ',' : ''}
                  {(exporterData?.addressTwo) ? (exporterData?.addressTwo) + ' - ' + exporterData?.postalCode : '' + "," + exporterData?.country}
                  <br />usfda reg no:{exporterData?.usfdaRegNo}
                </div>
                </td>
                <td colSpan={2} style={{ border: "1px solid black" }}>
                {/* <div style ={{ border: "1px solid black" }}> */}&nbsp;&nbsp;&nbsp;
                {plantDetails?.saleOrderItems?.[0]?.customeraddress?.[0] ? `${plantDetails.saleOrderItems[0].customeraddress[0]},` : '-'}<br /> &nbsp;&nbsp;
                {plantDetails?.saleOrderItems?.[0]?.customeraddress?.[1] 
  ? plantDetails.saleOrderItems[0].customeraddress[1] + "," 
  : '-'}
{plantDetails?.saleOrderItems?.[0]?.customeraddress 
  ? plantDetails.saleOrderItems[0].customeraddress + "," 
  : '-'}
{plantDetails?.saleOrderItems?.[0]?.customeraddress 
  ? plantDetails.saleOrderItems[0].customeraddress 
  : '-'}
                  <br/> &nbsp;&nbsp; FDA REGISTRATION &nbsp; NO. {unitsData?.consigneefdaRegNumber}
                  {/* </div> */}
                  </td>
              </tr>

              <tr>
                <td colSpan={2}><b> &nbsp;&nbsp; Ship To ( Name and Address ) :</b></td>
                <th colSpan={2} style={{ border: "1px solid black",backgroundColor:"grey",color:"white" }} ><b>For FBGS &nbsp; use only</b></th>
              </tr>

              <tr>
                <td colSpan={2} style={{ paddingRight:"20px" }} >
                <div style ={{ border: "1px solid black", paddingLeft:"18px",paddingRight:"10px",height:"50px" }}>
                          &ensp;                  {(plantDetails?.saleOrderItems[0]?.destinationDetails ? (plantDetails?.saleOrderItems[0]?.destinationDetails)?.toUpperCase() + "," : '') + (plantDetails?.country ? plantDetails?.country : '')}                  <br/>
</div></td>
                <td colSpan={2} style={{ border: "1px solid black", padding:"5px" }} rowSpan={5}>
                    &nbsp;<b>Information Completed:</b><br />
                    &nbsp;<b><td style={{ border: "1px solid black", width: "25px" }}>&nbsp;</td>&nbsp;Yes</b>&ensp;&ensp;<b><td style={{ border: "1px solid black", width: "25px" }}>&nbsp;</td>&nbsp;No</b><br />
                    &nbsp;<b>Data Submited Date:</b>
                    &nbsp;<td style={{ border: "1px solid black", width: "300px" }} >&nbsp;</td>
                    <br />
                    &nbsp;<b>SID:</b>
                    &nbsp; <td style={{ border: "1px solid black", width: "300px" }} >&nbsp;</td>
                    <br />
                    &nbsp;<b>Client Code:</b>
                    &nbsp;<td style={{ border: "1px solid black", width: "300px" }} >&nbsp;</td>
                    <br />
                    &nbsp;<b>Filing Date:</b>
                    &nbsp;<td style={{ border: "1px solid black", width: "300px" }} >&nbsp;</td>
                    <br />
                    &nbsp;<b>Bill OnFile Date:</b>
                    &nbsp;<td style={{ border: "1px solid black", width: "300px" }} >&nbsp;</td>
                    <br />
                </td>
              </tr>

              <tr style={{ fontWeight: "bold" }}>
                <td  colSpan={2}> &nbsp;&nbsp; Container Stuffing Location ( Name and Address &nbsp; )</td>
              </tr>

              <tr>
                <td  colSpan={2} style={{paddingRight:"20px"}}>
                <div style ={{ border: "1px solid black", paddingLeft:"18px",paddingRight:"10px" }}>
                  {(exporterData?.name) ? exporterData?.name : ''}<br />
                  <h4>SUPPLIERS &nbsp;( SELLER &nbsp;) ADDRESS &nbsp; :</h4>
                  {(exporterData?.addressOne) ? exporterData?.addressOne + ',' : ''}
                 
                  {(exporterData?.addressTwo) ? (exporterData?.addressTwo) + ' - ' + exporterData?.postalCode : '' + "," + exporterData?.country}<br />usfda reg no:{exporterData?.usfdaRegNo}
                </div>
                  </td>
              </tr>

              <tr style={{ fontWeight: "bold" }}>
                <td  colSpan={2}> &nbsp;&nbsp; Consolidator (Stuffer) NAME and Address</td>
              </tr>

              <tr >
                <td style={{paddingRight:"20px"}}  colSpan={2}>
                <div style ={{ border: "1px solid black",height:"108px" }}>
              &nbsp;{linerAddress[0]?.name ? linerAddress[0]?.name : '-'}<br />
              &nbsp;{linerAddress[0]?.linerAddress?linerAddress[0]?.linerAddress:"-"}<br />
                {/* &nbsp;&nbsp;{((plantDetails?.invoicedPlant?.postalCode) ? plantDetails?.invoicedPlant?.postalCode : "") + "," + ((plantDetails?.invoicedPlant?.distirctName) ? plantDetails?.invoicedPlant?.distirctName : "")}<br />
                &nbsp;&nbsp;{((plantDetails?.invoicedPlant?.stateName) ? plantDetails?.invoicedPlant?.stateName : "") + "," + ((plantDetails?.invoicedPlant?.countryName) ? plantDetails?.invoicedPlant?.countryName : "")}<br /> */}
                  </div>
                </td>
              </tr>

              <br />
              <tr>
                <th colSpan={2}>Manufacture( Name and address )</th>
                <th >Country Of Origin</th>
                <th >Commodity HTS-6 Number Or Products
                  <br /> Description With Commercial Invoice attached:</th>
              </tr>
              <tr>
                <td style ={{ border: "1px solid black", paddingLeft:"18px",paddingRight:"10px",whiteSpace: 'pre-line' }} colSpan={2} >
                &nbsp;&nbsp;{exporterData?.name}
                  <br /><br />
                  <h6>&nbsp;&nbsp;MANUFACTURERS &nbsp; ADDRESS &nbsp; :</h6>
                  &nbsp;&nbsp; {plantDetails?.invoicedPlant?.villageName && `${plantDetails.invoicedPlant.villageName}, `}
                  &nbsp;&nbsp; {plantDetails?.invoicedPlant?.mandalName && `${plantDetails.invoicedPlant.mandalName}`}
                  <br />
                  &nbsp;&nbsp; {plantDetails?.invoicedPlant?.postalCode && `${plantDetails.invoicedPlant.postalCode}, `}
                  &nbsp;&nbsp;{plantDetails?.invoicedPlant?.distirctName && `${plantDetails.invoicedPlant.distirctName}`}
                  <br />
                  &nbsp;&nbsp;{plantDetails?.invoicedPlant?.stateName && `${plantDetails.invoicedPlant.stateName}, `}
                  &nbsp;&nbsp;{plantDetails?.invoicedPlant?.countryName && `${plantDetails.invoicedPlant.countryName}`}
                  <br />
                  &nbsp;&nbsp;<h6 style={{ display: 'inline' }}>FDA Registration &nbsp; Number &nbsp; :</h6>&ensp;
                  &nbsp;&nbsp; {plantDetails?.invoicedPlant?.fdaRegNumber}
                  <br />
                  &nbsp;&nbsp;{plantDetails?.invoicedPlant?.feiNumber && (
                    <>
                     &nbsp;<h6 style={{ display: 'inline' }}>FEI Number:</h6> &nbsp;&nbsp; &ensp;{plantDetails.invoicedPlant.feiNumber}
                    </>
                  )}
                </td>

                <td className='ta-b'>&nbsp;&nbsp;INDIA</td>
                <td className='ta-b'>&nbsp;&nbsp;{plantDetails?.saleOrderItems[0]?plantDetails?.saleOrderItems[0]?.hsnCode?.replace(/^\D+/, ''):"-"}</td>

              </tr>

              <tr >
                <td className='ta-b' colSpan={2} style={{ height: "100px" }}>&nbsp;</td>
                <td className='ta-b'>&nbsp;</td>
                <td className='ta-b'>&nbsp;</td>

              </tr>

            </table>
          </div>


        </body>
      </html>
    </>
    // </Card>
  );

}

export default IsfWorksheet;
